import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import apiService from '../../reduxs/apiService'

import { Style } from './style'
import { IMG } from '../../themes'
import { Loader } from '../../components'
import { THANKYOU } from '../../helpers/constants'

const Thankyou = ({ params, colorTheme }) => {
  const { bookingId, status } = params
  const [bookingDetail, setBookingDetail] = useState()
  const isAccepted = status === 'accepted'

  useEffect(() => {
    const getBookingDetail = async () => {
      const response = await apiService.get('rest/v1/getdetail_booking', { bookingId })

      setBookingDetail(response.data)
    }
    getBookingDetail()
  }, [bookingDetail])

  let startTime = ''
  let endTime = ''

  if (!isEmpty(bookingDetail)) {
    startTime = moment(bookingDetail.startDatetime).format('HH:mm')
    endTime = moment(bookingDetail.endDatetime).format('HH:mm')
  }

  return (
    <Style isAccepted={isAccepted}>
      { !isEmpty(bookingDetail) ? (
        <>
          <div className='header-thankyou'>
            <img alt='logo' src={IMG['vich-logo.svg']} />
          </div>
          <div className='content-thankyou'>
            <div className='title'>{ THANKYOU.TITLE['EN'] }</div>
            <div className='status'>
              { THANKYOU.YOU_HAS['EN'] }&nbsp;<span>"{status}"</span>&nbsp;{ THANKYOU.INVITATION['EN'] }
            </div>
            <div className='detail'>
              <span>{bookingDetail.projectName}</span> {THANKYOU.WHEN['EN']} {moment().format('ddd MMM DD, YYYY')}
              <br/>{startTime}-{endTime} @ {bookingDetail.roomName}
            </div>
            <div className='footer-thankyou'>
              { THANKYOU.COPY_RIGHT['EN'] }
            </div>
          </div>
        </>)
      :
        <Loader colorTheme={colorTheme} />
      }
    </Style>
  )
}

export default Thankyou
